import { API_URL } from '../../app/apiConfig';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = { 'content-type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function addToCart(item) {
  const response = await fetch(`${API_URL}/api/cart`, {
    method: 'POST',
    body: JSON.stringify(item),
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  const data = await response.json();
  return { data };
}

export async function fetchItemsByUserId() {
  const response = await fetch(`${API_URL}/api/cart`, {
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  const data = await response.json();
  return { data };
}

export async function updateCart(update) {
  const response = await fetch(`${API_URL}/api/cart/` + update.id, {
    method: 'PATCH',
    body: JSON.stringify(update),
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  const data = await response.json();
  return { data };
}

export async function deleteItemFromCart(itemId) {
  const response = await fetch(`${API_URL}/api/cart/` + itemId, {
    method: 'DELETE',
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  await response.json();
  return { data: { id: itemId } };
}

export async function resetCart() {
  const response = await fetchItemsByUserId();
  const items = response.data || [];
  for (const item of items) {
    await deleteItemFromCart(item.id);
  }
  return { data: { status: 'success' } };
}
